export default __webpack_public_path__ + "static/media/location24.d4c076c1.svg";